import React from 'react';


const ErrorIcon = () => {

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.23066 13.9862C1.59342 13.9862 0.866413 12.6459 1.68294 11.2032L6.45645 2.43463C7.28578 1.00696 8.73502 0.981975 9.54839 2.44239L14.3155 11.201C15.1323 12.6488 14.408 13.9862 12.769 13.9862H3.23066ZM7.51982 4.99953V9.70786C7.51982 9.97296 7.73473 10.1879 7.99982 10.1879C8.26492 10.1879 8.47983 9.97296 8.47983 9.70786V4.99953C8.47983 4.73444 8.26492 4.51953 7.99982 4.51953C7.73473 4.51953 7.51982 4.73444 7.51982 4.99953ZM8.56315 11.6529C8.56315 11.964 8.31094 12.2162 7.99982 12.2162C7.6887 12.2162 7.43649 11.964 7.43649 11.6529C7.43649 11.3417 7.6887 11.0895 7.99982 11.0895C8.31094 11.0895 8.56315 11.3417 8.56315 11.6529Z" fill="#333333" />
      <mask id="mask4" mask-type="alpha" maskUnits="userSpaceOnUse" x="1" y="1" width="14" height="13">
        <path fillRule="evenodd" clipRule="evenodd" d="M3.23066 13.9862C1.59342 13.9862 0.866413 12.6459 1.68294 11.2032L6.45645 2.43463C7.28578 1.00696 8.73502 0.981975 9.54839 2.44239L14.3155 11.201C15.1323 12.6488 14.408 13.9862 12.769 13.9862H3.23066ZM7.51982 4.99953V9.70786C7.51982 9.97296 7.73473 10.1879 7.99982 10.1879C8.26492 10.1879 8.47983 9.97296 8.47983 9.70786V4.99953C8.47983 4.73444 8.26492 4.51953 7.99982 4.51953C7.73473 4.51953 7.51982 4.73444 7.51982 4.99953ZM8.56315 11.6529C8.56315 11.964 8.31094 12.2162 7.99982 12.2162C7.6887 12.2162 7.43649 11.964 7.43649 11.6529C7.43649 11.3417 7.6887 11.0895 7.99982 11.0895C8.31094 11.0895 8.56315 11.3417 8.56315 11.6529Z" fill="white" />
      </mask>
      <g mask="url(#mask4)">
        <rect width="16" height="16" fill="#BD0000" />
      </g>
    </svg>

  );
}



export default ErrorIcon;